export const HorseSilhouette = ({ color = "#6b3f22", size = 96, className = "" }) => (
  <svg viewBox="0 0 120 100" width={size} height={size * 0.8} className={className}
    role="img" aria-label="mustang">
    {/* legs */}
    {[32, 46, 74, 90].map((x) => (
      <rect key={x} x={x} y="58" width="7" height="32" rx="3" fill={color} />
    ))}
    {/* hooves */}
    {[32, 46, 74, 90].map((x) => (
      <rect key={`h${x}`} x={x} y="86" width="7" height="5" rx="1.5" fill="rgba(0,0,0,0.35)" />
    ))}
    {/* tail */}
    <path d="M26 42 Q12 50 16 74 L23 72 Q22 54 33 50 Z" fill={color} />
    {/* body */}
    <ellipse cx="60" cy="50" rx="34" ry="17" fill={color} />
    {/* neck + chest */}
    <path d="M84 42 Q99 38 103 20 L112 24 Q109 46 92 56 Z" fill={color} />
    {/* head */}
    <path d="M103 20 Q117 12 119 22 L114 35 Q105 35 99 29 Z" fill={color} />
    {/* ear */}
    <path d="M103 18 L105 7 L110 16 Z" fill={color} />
    {/* mane */}
    <path d="M90 30 Q96 16 105 20 L102 30 Q96 32 93 44 Z" fill="rgba(0,0,0,0.25)" />
    {/* eye */}
    <circle cx="109" cy="24" r="1.7" fill="#111" />
  </svg>
);
